export default __webpack_public_path__ + "static/media/CivilEng_Shapes-02.0fa65c60.png";